import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Modal,
  LoaderIndicator,
  HelperViewStatus,
  HeadingDisplay,
  BaseText,
  ListDisplay,
  InitialAvatarIcon,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

import {
  getProductOrderDetails,
  cancelOrder,
  IProductOrderDetails
} from '@/modules/home/services/orders';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Emits {
  (event: 'close'): void;
}

interface Props {
  isOpen: boolean;
  orderId: string;
  productType: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductOrderDetails',
  props: {
    isOpen: { type: Boolean },
    orderId: null,
    productType: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  orderId: string;
  productType: string;
};





const orderDetails = ref<IProductOrderDetails | null>(null);
const isLoading = ref(false);
const hasError = ref(false);
const cancelModalOpen = ref(false);

watch(
  () => props.isOpen,
  async isOpen => {
    if (isOpen) {
      fetchOrderDetails();
    }
  }
);

function handleClose() {
  cancelModalOpen.value = false;
  emit('close');
}

async function fetchOrderDetails() {
  try {
    isLoading.value = true;
    hasError.value = false;

    orderDetails.value = await getProductOrderDetails(
      props.orderId,
      props.productType
    );
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function handleCancelOrder() {
  try {
    isLoading.value = true;

    const response = await cancelOrder(props.orderId);

    notify({
      group: 'wrn-notifications',
      text: response.title,
      type: NotificationTypes.success
    });
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível realizar a operação, por favor tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
    emit('close');
  }
}

return { __sfc: true,emit, props, orderDetails, isLoading, hasError, cancelModalOpen, handleClose, fetchOrderDetails, handleCancelOrder, Modal, LoaderIndicator, HelperViewStatus, HeadingDisplay, BaseText, ListDisplay, InitialAvatarIcon, ButtonContainer, ButtonPrimary, ButtonSecondary, NebraskaColors }
}

})